module.exports = __webpack_public_path__ + "media/src/img/idea-136111e263ab4aba3367741074b31d73fbe34fcaf23975f9c9b2e67e9789324d.svg";